export default __webpack_public_path__ + "static/media/dislike.5261d452.svg";